<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn icon @click="emitChange">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-gestao-entrega-filtro @change="emitChange"/>
      <px-search-text class="rounded-tag-small"
                      label="Busque por um produto ou código" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GestaoEntregaFiltro from './GestaoEntregaFiltro.vue';

export default {
  computed: {
    ...mapGetters('gestaoEntrega', ['statusOptions']),
    selectedStatus: {
      get() {
        return this.$store.getters['gestaoEntrega/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('gestaoEntrega/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['gestaoEntrega/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('gestaoEntrega/searchText', searchText);
      },
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  components: {
    pxGestaoEntregaFiltro: GestaoEntregaFiltro,
  },
};
</script>
